import React from 'react';
import { connect } from 'react-redux';
import { findMatch } from '@/utils/resultsHelper';
import ScrollableCards from '@/components/cards/ScrollableCards';
import DictionaryFieldCardItems from '../components/DictionaryFieldCardItems';
import { resolveCatalogueTemplate } from '../../catalogue/helper';
import { datasetPerms } from '../../sharing/state/state';
import { canEditDataset } from '../../helper';

const DictionaryFieldCards = ({
  canEdit,
  category,
  code,
  dictionaryUUID,
  fields,
  isEditing,
  lookups,
  template,
}) => (
  <ScrollableCards itemsPerRow={1} className="aridhia-dictionary-field-cards">
    <DictionaryFieldCardItems
      canEdit={canEdit}
      category={category}
      code={code}
      dictionaryUUID={dictionaryUUID}
      fields={fields}
      isEditing={isEditing}
      lookups={lookups}
      template={template}
    />
  </ScrollableCards>
);

const mapStateToProps = ({
  auth: { role },
  catalogues: { templates },
  datasets: { datasets },
}, ownProps) => {
  const { dataset, template } = resolveCatalogueTemplate(datasets, templates, ownProps, {
    dictionaries: [],
    isEditing: false,
    permissions: datasetPerms(),
  });
  const dictionary = findMatch(dataset.dictionaries, dataset.activeDictionaryName, 'name') || {
    uuid: null, fields: [], lookups: {},
  };

  return ({
    canEdit: canEditDataset(dataset, role),
    dictionaryUUID: dictionary.uuid,
    fields: dictionary.fields,
    isEditing: dataset.isEditing,
    lookups: dictionary.lookups,
    template,
  });
};

export default connect(mapStateToProps)(DictionaryFieldCards);
